import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ValidationMessageKey } from 'app/enums';

export function matchValidator(key1: string, key2: string, errorName: string): ValidatorFn {
    return (formGroup: AbstractControl): ValidationErrors | null => {
        const control1 = formGroup.get(key1);
        const control2 = formGroup.get(key2);

        if (!control1 || !control2) {
            return null;
        }

        if (control1.errors && !control1.errors[errorName] && control1.errors[ValidationMessageKey.Required]) {
            return null;
        }

        if (control2.errors && !control2.errors[errorName] && control2.errors[ValidationMessageKey.Required]) {
            return null;
        }

        if (control1.value !== control2.value) {
            control1.setErrors({ ...control1.errors, [errorName]: true });
            control2.setErrors({ ...control2.errors, [errorName]: true });
        } else {
            if (control1.errors) {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const { [errorName]: _removed, ...otherErrors } = control1.errors;
                control1.setErrors(Object.keys(otherErrors).length ? otherErrors : null);
            }
            if (control2.errors) {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const { [errorName]: _removed, ...otherErrors } = control2.errors;
                control2.setErrors(Object.keys(otherErrors).length ? otherErrors : null);
            }
        }

        return null;
    };
}

export function passwordValidator(key: string, errorName: string): ValidatorFn {
    return (formGroup: AbstractControl): ValidationErrors | null => {
        const control = formGroup.get(key);

        if (!control) {
            return null;
        }

        if (control.errors && !control.errors[errorName] && control.errors[ValidationMessageKey.Required]) {
            return null;
        }

        const value = control.value as string;
        const minLength = value.length >= 8;
        const hasSpecial = /[^A-Za-z0-9]/.test(value);
        if (!minLength || !hasSpecial) {
            control.setErrors({ ...control.errors, [errorName]: true });
        } else {
            if (control.errors) {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const { [errorName]: _removed, ...otherErrors } = control.errors;
                control.setErrors(Object.keys(otherErrors).length ? otherErrors : null);
            }
        }

        return null;
    };
}

export function passwordValidator2(control: import('@angular/forms').AbstractControl) {
    const value = control.value as string;
    //if (!value) return { password: 'Password is required' };
    const minLength = value.length >= 8;
    const hasSpecial = /[^A-Za-z0-9]/.test(value);
    if (!minLength || !hasSpecial) {
        return {
            password: 'Password must be at least 8 characters and contain at least one special character.'
        };
    }
    return null;
}
